import component from './predictionFunnel.vue'

export default component
